import React, {Component} from 'react';
import Button from '../Button';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import './styles.less';

export default class ProductList extends Component {
  static propTypes = {
    onNew: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,
    products: PropTypes.object.isRequired,
    keyName: PropTypes.string.isRequired,
    selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  };

  constructor(props, context) {
    super(props, context);
    this.onSelect = this.onSelect.bind(this);
    this.handleArrows = this.handleArrows.bind(this);
    this.sortedProductTokens = [];
    this.state = {
      selected: this.props.selected
    }
  }

  componentDidMount() {
    window.document.addEventListener('keydown', this.handleArrows);
  }

  componentWillUnmount() {
    window.document.removeEventListener('keydown', this.handleArrows);
  }

  handleArrows(event) {
    const isUpArrow = event.key === 'ArrowUp';
    const isDownArrow = event.key === 'ArrowDown';

    if (!isDownArrow && !isUpArrow) return;

    const selectedToken = this.state.selected;
    const indexAt = this.sortedProductTokens.findIndex(token => token === selectedToken);
    const directionIndex = isUpArrow ? indexAt - 1 : indexAt + 1;

    if (directionIndex < this.sortedProductTokens.length && directionIndex >= 0) {
      event.preventDefault();
      const newToken = this.sortedProductTokens[directionIndex];
      this.props.onSelect(newToken);
      this.setState({
        selected: newToken
      });
    }

  }

  onSelect(event) {
    const token = event && event.currentTarget && event.currentTarget.dataset && event.currentTarget.dataset.token;
    event.stopPropagation();

    this.props.onSelect(token);
    this.setState({
      selected: token
    });
  }

  render() {
    const tokens = Object.keys(this.props.products);
    const activeTokens = tokens.filter(token => !!this.props.products[token].active);
    const inactiveTokens = tokens.filter(token => !this.props.products[token].active);
    this.sortedProductTokens = [...activeTokens, ...inactiveTokens];

    const listItems = this.sortedProductTokens.map(token => {
      const product = this.props.products[token];
      const className = [
        (token === this.props.selected) ? 'selected' : '',
        !product.token ? 'uncreated' : ''
      ].join(' ');
      const value = product[this.props.keyName] || 'Missing Product Name';
      // Show an active icon. The icon is not clickable though.
      const active = <FontAwesome name={product.active ? "toggle-on" : "toggle-off"}/>;
      return (
        <li key={token}
            className={className}
            data-token={token}
            onClick={this.onSelect}>
          {active} {value}
        </li>);
    });

    return (
      <div className="product-list-component">
        <div className="product-list-component-title">Products</div>
        <ul onClick={this.onSelect}>{listItems}</ul>
        <Button onClick={() => this.props.onNew()}>New Product</Button>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/ProductList/index.jsx
 **/